import { render, staticRenderFns } from "./ListInternalOrders.vue?vue&type=template&id=871ffa78"
import script from "./ListInternalOrders.vue?vue&type=script&lang=js"
export * from "./ListInternalOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports